<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import mznmezunlar from "@/models/mznmezunlar";
import Banner from "../components/banner";
import Drawer from "vue-simple-drawer";
import forminput from "../formcomponet/forminput.vue";
import formcombobox from "../formcomponet/formcombobox.vue";
import moment from "moment";

export default {
  props: {
    WebSiteConfig: [String, Object],
  },
  mixins: [apibtoast, apigeneric, mznmezunlar],
  page: {
    title: "Web Siteleri",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    Banner,
    Drawer,
    forminput,
    formcombobox

  },
  created() {
    this.IsFirma();
  },
  data() {
    return {
      TotalMezunSayisi: null,
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      TableData: {},
      IsUserFirma: false,
      x: "",
      Filter: {
        Adisoyadi: "",
        Mezuniyetyili: "",
        Eposta: "",
        Telefon: "",
        Yasadigisehir: "",
        Calismadurumu: "",
        Isaramadurumu: "",
        Saglikengeli: "",
        Ehliyet: "",
        Yasadigiulke: "",
        Cinsiyet: "",
        Uyruk: "",
        Bolum: "",
        Fakülte: "",
        Ogrenimdurumu: ""
      },
      FilitrelemePenceresi: false,
    };
  },
  validations: {
    Filter: {
      Adisoyadi: {},
      Mezuniyetyili:{}, 
      Eposta: {},
      Telefon: {},
      Yasadigisehir: {},
      Calismadurumu: {},
      Isaramadurumu: {},
      Saglikengeli: {},
      Ehliyet: {},
      Cinsiyet: {},
      Bolum: {},
      Fakülte: {},
      Ogrenimdurumu: {}


    },
  },
  methods: {
    rightDrawer() {
      this.FilitrelemePenceresi = !this.FilitrelemePenceresi;
    },
    Get() {
      this.MezunSayi();
      let Filter =
        "&Onay=true" +
        "&Arkadaskontroluserid=" +
        this.TokenUserId +
        "&Adisoyadi=" +
        this.Filter.Adisoyadi +
        "&Mezuniyettarihi=" +
        this.Filter.Mezuniyetyili +
        "&Eposta=" +
        this.Filter.Eposta +
        "&Telefon=" +
        this.Filter.Telefon +
        "&Yasadigisehir=" +
        this.Filter.Yasadigisehir +
        "&Calismadurumu=" +
        this.Filter.Calismadurumu +
        "&Isaramadurumu=" +
        this.Filter.Isaramadurumu +
        "&Saglikengeli=" +
        this.Filter.Saglikengeli +
        "&Ehliyet=" +
        this.Filter.Ehliyet +
        "&Cinsiyet=" +
        this.Filter.Cinsiyet +
        "&Bolum=" +
        this.Filter.Bolum +
        "&Fakülte=" +
        this.Filter.Fakülte +
        "&Ogrenimdurumu=" +
        this.Filter.Ogrenimdurumu; 
      this.ActionsFilterGet({
        Service: this.$config.API_URL_2 + "mznmezunlar",
        Page: this.Page,
        Filter: Filter,
      }).then((res) => {
        this.TableData = res.Data;
        for(var Data in this.TableData){
          if(this.TableData[Data].Egitimbilgileri != null){
            if((JSON.parse(this.TableData[Data].Egitimbilgileri).length) > 0 )
            {
              this.TableData[Data].Egitimbilgileri = this.EnSonOkul(JSON.parse(this.TableData[Data].Egitimbilgileri))
            }

          }else{
            this.TableData[Data].Egitimbilgileri = this.TableData[Data].Egitimbilgileri
            }
        
  
        }
        this.Page.PageDataSize = res.TotalCount;
      });

    },
    MezunSayi(){
      this.ActionsGet({
            Service: this.$config.API_URL_2 + "mznmezunlar",
            Page: this.Page,
          }).then((res) => {
            this.TotalMezunSayisi = res.TotalCount;
          });
},
    ArkadasListesiAdd(ArkadasId) {
      let FormData = {
        Userid: ArkadasId,
        Arkadasuserid: this.TokenUserId,
        Onay: false

      };
      this.Post(this.$config.API_URL_2 + "mznarkadaslistesi", FormData);

    },

    ArkadasListesiDelete(ArkadasId) {
      let FormData = {
        Userid: this.TokenUserId,
        Arkadasuserid: ArkadasId,
      };
      this.ActionsDeleteParametre({
        Service: this.$config.API_URL_2 + "mznarkadaslistesi",
        Parametre: FormData
      }).then((res) => {
        if (res.Succeeded == true) {
          let FormData = {
            Userid: this.TokenUserId,
            Arkadasuserid: ArkadasId,
          };
          this.ActionsDeleteParametre({
            Service: this.$config.API_URL_2 + "mznarkadaslistesi",
            Parametre: FormData
          }).then((res) => {
            if (res.Succeeded == true) {
              if (res.Data.Succeeded != false) {
                this.$toast.success(this.$t("ToasMessage.DeletePozitif"));
                this.Get();
              }
            } else {
              this.$toast.error(this.$t("ToasMessage.DeleteNegatif"));
            }
          });
        }
      });

    },
    EnSonOkul(Data){ //data = this.TableData[Data].Egitimbilgileri
     var enBuyuk = Data[0];
    for(var Egitim in Data){
        if(Data[Egitim].MezuniyetTarihi>enBuyuk.MezuniyetTarihi &&   Data[Egitim].MezuniyetTarihi < moment(new Date()).format("YYYY-MM-DD"))
        {
            enBuyuk=Data[Egitim];
        }
    }
    return enBuyuk;
    },
    Yildizla(isimSoyisim) {
      let isimSoyisimDizisi = isimSoyisim.split(' ');
      let yıldızlıIsimSoyisim = isimSoyisimDizisi.map(function(kelime) {
        if (kelime.length > 1) {
          return kelime[0] + '*'.repeat(kelime.length - 1);
        }
        return kelime; // Eğer kelime sadece 1 karakterden oluşuyorsa, onu değiştirmeden bırak
      });
      return yıldızlıIsimSoyisim.join(' ');
    },
    IsFirma() {
      this.ActionsFilterGet({
        Service: this.$config.API_URL_2 + "mznmezunlar",
        Page: this.Page,
        Filter: "&Userid=" + this.TokenUserId,
      }).then((res) => {
        if (res.Data.length > 0) {
          this.IsUserFirma = false;
        } else {
          this.IsUserFirma = true;
        }
      });
    },
    IsimGoster(Data) {
      if (!Data || !Data.Adisoyadi) return "";

      // Kendi profili ise açık göster
      if (Data.Userid === this.TokenUserId) {
        return Data.Adisoyadi;
      }

      let gizlilik = {};
      if (Data.Gizlilik) {
        try {
          gizlilik = typeof Data.Gizlilik === 'string' ? JSON.parse(Data.Gizlilik) : Data.Gizlilik;
        } catch (e) {
          gizlilik = {};
        }
      }
      const kisiselBilgiler = gizlilik.KisiselBilgiler;

      // Gizlilik Koşulları
      const arkadasMi = Data.Arkadasmi === true;
      const firmaMi = this.IsUserFirma === true;

      const kosul1 = arkadasMi && (kisiselBilgiler == 1 || kisiselBilgiler == 3) && !firmaMi;
      const kosul2 = kisiselBilgiler == 4;
      const kosul3 = (kisiselBilgiler == 2 || kisiselBilgiler == 3) && firmaMi;

      if (kosul1 || kosul2 || kosul3) {
        return Data.Adisoyadi;
      }

      return this.Yildizla(Data.Adisoyadi);
    }


  },
};
</script>

<template>
  <Loader>
    <Layout>
      <Banner />
 <!--     <div class="row" style="text-align: center;">
        <div class="col-md-1"> </div>
              <div class="col-md-1"> </div>
                <div class="alert alert-info  col-md-2 mt-2 mx-1" role="alert">
            Lisans Mezunu:   <h1  class="display-4">148</h1>

          </div>
                <div class="alert alert-primary col-md-2 mt-2 mx-1" role="alert">
            Ön Lisans Mezunu:   <h1  class="display-4">1332</h1>
          </div>
                <div class="alert alert-success  col-md-2 mt-2 mx-1" role="alert">
            Enstitü Mezunu:    <h1  class="display-4">118 </h1>
          </div> 
                <div class="alert alert-dark  col-md-2 mt-2 mx-1" role="alert">
            Toplam Mezun:             <h1  class="display-4">1598 </h1>
          </div>
             
      </div> -->

      <div class="graduates">
        <div class="container">

          <div class="table-graduate"> 
            <p class="h2 text-center cl-service-dark">Mezun Öğrenciler</p>
            <div class="container">
              <div class="search-bar">
                <div class="row c-flex">
                  <div class="col-md-2 l-flex">
                    <div class="form-group full-width">
                      <input v-model="Filter.Adisoyadi" type="name" name="name" class="form-control" placeholder="Ad" />
                    </div>
                  </div>
                  <div class="col-md-2 l-flex">
                    <div class="form-group full-width">
                        <b-form-group placeholder="Öğrenim Durumu">
                                          <select v-model="Filter.Ogrenimdurumu" class="form-select">
                                            <option value="">Seçiniz...</option>
                                            <option value="Ön lisans">Ön lisans</option>
                                            <option value="Yüksek lisans">Yüksek lisans</option> 
                                            <option value="Lisans">Lisans</option>
                                            <option value="Doktora">Doktora</option>
                                          </select>
                       </b-form-group>
                    </div>
                  </div>
                  
                  <div class="col-md-2 l-flex">
                    <div class="form-group full-width">
                      <input v-model="Filter.Fakülte" type="name" name="number" class="form-control"
                        placeholder="MYO/Fakülte/Enstitü" />
                    </div>
                  </div>
                  <div class="col-md-2 l-flex">
                    <div class="form-group full-width">
                      <input v-model="Filter.Bolum" type="name" name="name" class="form-control"
                        placeholder="Bölüm" />
                    </div>
                  </div>
                  <div class="col-md-2 l-flex">
                    <div class="form-group full-width">
                      <input v-model="Filter.Mezuniyetyili" type="number" name="number" class="form-control"
                        placeholder="Mezuniyet Tarihi" />
                    </div>
                  </div>
                 
          <!--        <div class="col-md-3 l-flex">
                    <div class="form-group full-width">
                      <input v-model="Filter.Eposta" class="form-control" placeholder="E-Posta" />
                    </div>
                  </div>
                  <div class="col-md-3 l-flex">
                    <div class="form-group full-width">
                      <input v-model="Filter.Telefon" type="number" name="number" class="form-control"
                        placeholder="Telefon" />
                    </div>
                  </div> -->
                  <div class="col-md-1">
                    <button type="button " @click="Get()" class="btn btn-dark full-width">
                      Ara
                    </button>
                  </div>
                  <div class="col-md-1 l-flex ">
                    <b-button type="button" class="btn btn-secondary btn-rounded full-width"
                    v-if="WebSiteConfig.Mezungelismisfiltreleme"
                     @click="rightDrawer">
                      <i class="mdi mdi-text-search"></i>
                    </b-button>

                  </div>
                </div>
              </div>

              <ul class="table-main">
                <li class="head bg-service">
                  <div class="row">
                    <div class="col-md-10">
                      <span class="order fs-6">{{
                      $t("mznmezunlar.Table.Adisoyadi")
                      }}</span>
                    </div>
          <!--          <div class="col-md-2">
                      <span class="order fs-6">{{
                      $t("mznmezunlar.Table.OgrenimDurumu")
                      }}</span>
                    </div>
                    <div class="col-md-2">
                      <span class="order fs-6">{{
                      $t("mznmezunlar.Table.Fakulte/Enstitu")
                      }}</span>
                    </div>
                    <div class="col-md-3">
                      <span class="order fs-6">{{
                      $t("mznmezunlar.Table.Bolum")
                      }}</span>
                    </div>
                    <div class="col-md-2">
                      <span class="fs-6">{{
                      $t("mznmezunlar.Table.MezuniyetYili")
                      }}</span>
                    </div>
-->
                   
                    <div class="col-md-1" style="text-align:center">
                      <span class="order fs-6">{{ $t("mznmezunlar.Table.Islem") }}</span>
                    </div>
                  </div>
                </li>
                <li v-for="(Data, index) in TableData" :key="index">
                  <div class="col-md-12">
                    <div class="row" >
                      <div class="col-md-10 l-flex">
                        <span class="order" >{{ IsimGoster(Data) }}</span>
                      </div>
               <!--      <div class="col-md-2 l-flex" >
                        <span class="order" >{{ Data.Egitimbilgileri.Ogrenimdurumu }}</span>
                      </div>
                      <div class="col-md-2 l-flex">
                        <span class="order">{{ Data.Egitimbilgileri.Fakülte }}</span>
                      </div>
                      <div class="col-md-3 l-flex">
                        <span class="order">{{ Data.Egitimbilgileri.Bolum }}</span>
                      </div>
                      <div class="col-md-2 l-flex"  >
                        <span class="order">{{ Data.Egitimbilgileri.MezuniyetTarihi | formatDateYear}}</span>
                      </div>          -->      
                      <div class="col-md-1" style="text-align:center">
                        <b-button-group>
                          <router-link class="btn btn-info bx bxs-user-detail mx-auto"
                            style="color: #00758f; font-size: 20px;" id="topnav-components" :to="'profil/' + Data.Id"
                            role="button">
                            <i></i>
                          </router-link>
                          <b-tooltip target="topnav-components" triggers="hover">
                            Detay
                          </b-tooltip>
                          <b-button v-if="!Data.Arkadasmi && TokenUserId != Data.Userid" variant="primary"
                            id="tooltip-1" @click="ArkadasListesiAdd(Data.Userid)"><i class="bx bx-user-plus"></i>
                          </b-button>
                          <b-tooltip target="tooltip-1" triggers="hover">
                            Arkadaş Ekle
                          </b-tooltip>


                          <b-button v-if="Data.Arkadasmi && TokenUserId != Data.Userid" variant="danger" id="tooltip-2"
                            @click="ArkadasListesiDelete(Data.Userid)"><i class="bx bx-user-minus"></i></b-button>
                          <b-tooltip target="tooltip-2" triggers="hover">
                            Arkadaş Sil
                          </b-tooltip>

                        </b-button-group>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
              <b-pagination class="pagination pagination-rounded justify-content-end mb-2" v-model="DefaultPage"
                :total-rows="Page.PageDataSize" :per-page="Page.PageSize" aria-controls="my-table"
                @input="ChangePage(DefaultPage)">
              </b-pagination>
            </div>
          </div>
        </div>
      </div>
      <Drawer @close="rightDrawer" :align="'right'" :closeable="true" :maskClosable="true" :zIndex="1002"
      v-if="WebSiteConfig.Mezungelismisfiltreleme">
        <div v-if="FilitrelemePenceresi">
          <div class="offcanvas-header">
            <h5 class="offcanvas-title" id="offcanvasExampleLabel">
              {{ $t("mznmezunlar.Filtreleme.Title") }}
            </h5>
          </div>
          <div class="offcanvas-body">
            {{ $t("mznmezunlar.Filtreleme.Content") }}
            <div class="mb-3 mt-4">
              <forminput :FormDataType="{
                FieldName: 'Adisoyadi',
                Field: 'input',
                FieldTitle: $t('mznmezunlar.Filtreleme.Adisoyadi'),
              }" :Value="Filter.Adisoyadi" :v="$v.Filter.Adisoyadi" @input="Filter.Adisoyadi = $event" />
            </div>
        <!--  <div class="mb-3 mt-4">
              <forminput :FormDataType="{
                FieldName: 'Tckimlikno',
                Field: 'input',
                FieldTitle: $t('mznmezunlar.Filtreleme.Tckimlikno'),
              }" :Value="Filter.Tckimlikno" :v="$v.Filter.Tckimlikno" @input="Filter.Tckimlikno = $event" />
            </div> -->  
            <div class="mb-3 mt-4">
              <forminput :FormDataType="{
                FieldName: 'Eposta',
                Field: 'input',
                FieldTitle: $t('mznmezunlar.Filtreleme.Eposta'),
              }" :Value="Filter.Eposta" :v="$v.Filter.Eposta" @input="Filter.Eposta = $event" />
            </div>
            <div class="mb-3 mt-4">
              <forminput :FormDataType="{
                FieldName: 'Telefon',
                Field: 'input',
                FieldTitle: $t('mznmezunlar.Filtreleme.Telefon'),
              }" :Value="Filter.Telefon" :v="$v.Filter.Telefon" @input="Filter.Telefon = $event" />
            </div>
            <div class="mb-3 mt-4">
              <formcombobox :FormDataType="{
                FieldName: 'Yasadigisehir',
                Field: 'input',
                FieldTitle: $t('mznmezunlar.Filtreleme.Yasadigisehir'),
                ComboDataArray: FormDataType.Yasadigisehir.ComboDataArray,
              }" :Value="Filter.Yasadigisehir" :v="$v.Filter.Yasadigisehir" @input="Filter.Yasadigisehir = $event" />
            </div>
            <div class="mb-3 mt-4">
              <formcombobox :FormDataType="{
                FieldName: 'Calismadurumu',
                Field: 'input',
                FieldTitle: $t('mznmezunlar.Filtreleme.Calismadurumu'),
                ComboDataArray: FormDataType.Calismadurumu.ComboDataArray,
              }" :Value="Filter.Calismadurumu" :v="$v.Filter.Calismadurumu" @input="Filter.Calismadurumu = $event" />
            </div>
            <div class="mb-3 mt-4">
              <formcombobox :FormDataType="{
                FieldName: 'Isaramadurumu',
                Field: 'input',
                FieldTitle: $t('mznmezunlar.Filtreleme.Isaramadurumu'),
                ComboDataArray: FormDataType.Isaramadurumu.ComboDataArray,
              }" :Value="Filter.Isaramadurumu" :v="$v.Filter.Isaramadurumu" @input="Filter.Isaramadurumu = $event" />
            </div>
            <div class="mb-3 mt-4">
              <formcombobox :FormDataType="{
                FieldName: 'Askerlik',
                Field: 'input',
                FieldTitle: $t('mznmezunlar.Filtreleme.Askerlik'),
                ComboDataArray: FormDataType.Askerlik.ComboDataArray,
              }" :Value="Filter.Askerlik" :v="$v.Filter.Askerlik" @input="Filter.Askerlik = $event" />
            </div>
            <div class="mb-3 mt-4">
              <formcombobox :FormDataType="{
                FieldName: 'Ehliyet',
                Field: 'input',
                FieldTitle: $t('mznmezunlar.Filtreleme.Ehliyet'),
                ComboDataArray: FormDataType.Ehliyet.ComboDataArray,
              }" :Value="Filter.Ehliyet" :v="$v.Filter.Ehliyet" @input="Filter.Ehliyet = $event" />
            </div>
            <div class="mb-3 mt-4">
              <formcombobox :FormDataType="{
                FieldName: 'Saglikengeli',
                Field: 'input',
                FieldTitle: $t('mznmezunlar.Filtreleme.Saglikengeli'),
                ComboDataArray: FormDataType.Saglikengeli.ComboDataArray,
              }" :Value="Filter.Saglikengeli" :v="$v.Filter.Saglikengeli" @input="Filter.Saglikengeli = $event" />
            </div>
     <!--      <div class="mb-3 mt-4">
              <formcombobox :FormDataType="{
                FieldName: 'Cinsiyet',
                Field: 'input',
                FieldTitle: $t('mznmezunlar.Filtreleme.Cinsiyet'),
                ComboDataArray: FormDataType.Cinsiyet.ComboDataArray,
              }" :Value="Filter.Cinsiyet" :v="$v.Filter.Cinsiyet" @input="Filter.Cinsiyet = $event" />
            </div> --> 



            <b-button @click="Get()" class="btn btn-primary" variant="primary">{{ $t("mznmezunlar.Filtreleme.Button") }}
            </b-button>
          </div>
        </div>
      </Drawer>
    </Layout>
  </Loader>
</template>
